
import { Component, Prop, Vue } from 'vue-property-decorator';

const DEFAULT_FILL = 'var(--neutralcolor-low-pure-fix)';

@Component
export default class Email extends Vue {
  @Prop({ default: DEFAULT_FILL }) fill!: string;
}
